import React from "react";
import { Link } from "react-router-dom";

const MetaTrader5MobileContentThree = () => {
  return (
    <div className="how__work__platform">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="content-left">
              <h2>Trade Anytime, Anywhere</h2>
              <p>
                MetaTrader 5 Mobile is available for both iOS and Android
                devices, offering a full suite of trading features for ultimate
                flexibility. The platform synchronizes seamlessly with desktop
                and web terminals, allowing traders to switch devices without
                losing progress or control. With advanced charting tools,
                real-time alerts, and instant order execution, you can react to
                market movements the moment they happen. The app is optimized
                for speed and stability, ensuring smooth performance even during
                periods of high volatility. Whether you're commuting, traveling,
                or away from your desk, MT5 Mobile keeps your trading
                uninterrupted and always within reach.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Download for iOS / Android
              </Link>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="thumb-right">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/platforms/meta_trader_5_mobile/meta_trader_5_mobile_2.png"
                }
                alt="computer images"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetaTrader5MobileContentThree;
